export default "__VITE_ASSET__Brj848s5__"